import React from "react"
import { Box, Typography, List, Divider } from "@mui/material"
import MenuItem from "./MenuItem"
import PropTypes from "prop-types"
import theme from "../../../theme/theme"
import { TokenService } from "../../../../services/token-service"

const MenuSection = ({ title, items, tokenService, useMaxHeight = false }) => {
    const isAdmin = tokenService.verifyUserIsAdmin()

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "row",
                height: useMaxHeight ? "-webkit-fill-available" : "auto",
            }}
        >
            <Divider
                orientation="vertical"
                flexItem
                sx={{
                    width: 2,
                    marginRight: 2,
                    py: 3,
                    backgroundColor: theme.palette.common.white,
                    border: "none",
                    "&::before, &::after": {
                        border: "none",
                    },
                }}
            />

            <Box
                sx={{
                    flex: 1,
                    gap: 1,
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <Typography
                    variant="textLarge"
                    sx={{
                        color: "common.white",
                    }}
                >
                    {title}
                </Typography>

                <List
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        p: 0,
                        gap: 1,
                        marginTop: "auto",
                    }}
                >
                    {items.map((item, index) => {
                        const hasTokenPermission = item.id
                            ? tokenService.verifyPermission(item.id)
                            : true

                        const hasPermission = isAdmin || hasTokenPermission
                        return (
                            <MenuItem
                                key={index}
                                item={item}
                                hasPermission={hasPermission}
                            />
                        )
                    })}
                </List>
            </Box>
        </Box>
    )
}

MenuSection.propTypes = {
    title: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.element.isRequired,
            name: PropTypes.string.isRequired,
            to: PropTypes.string.isRequired,
            id: PropTypes.string,
        })
    ).isRequired,
    tokenService: PropTypes.instanceOf(TokenService).isRequired,
    useMaxHeight: PropTypes.bool,
}

export default MenuSection
